import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.space8};
`;
